"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Keyboard_1 = require("../_Core/Keyboard");
var CloseThinIcon_1 = require("../Icons/Assets/CloseThinIcon");
var SearchIcon_1 = require("../Icons/Assets/SearchIcon");
var Localization_1 = require("../Localization");
var Searcher_styles_1 = require("./Searcher.styles");
exports.default = React.forwardRef(function (_a, ref) {
    var AriaLabel = _a.AriaLabel, HasErrors = _a.HasErrors, InitialSearch = _a.InitialSearch, IsDisabled = _a.IsDisabled, IsRequired = _a.IsRequired, LabelledBy = _a.LabelledBy, OnClear = _a.OnClear, OnKeyUp = _a.OnKeyUp, OnSearch = _a.OnSearch, Placeholder = _a.Placeholder, _b = _a.TextIndent, TextIndent = _b === void 0 ? "12px" : _b, _c = _a.MinimumCharactersToTrigger, MinimumCharactersToTrigger = _c === void 0 ? 3 : _c, _d = _a.DebounceTimeout, DebounceTimeout = _d === void 0 ? 500 : _d;
    var timeoutVal;
    var previousSearch = React.useRef(InitialSearch);
    var handleKeyPress = function (e) {
        if (Keyboard_1.IsEnter(e)) {
            e.stopPropagation();
            e.preventDefault();
        }
    };
    var handleKeyUp = function (e) {
        var value = e.target.value;
        window.clearTimeout(timeoutVal);
        if (OnKeyUp) {
            OnKeyUp(e);
        }
        if (Keyboard_1.IsEnter(e) && value) {
            OnSearch(value);
        }
        else {
            // Don't search if the input hasn't changed
            if (value === previousSearch.current) {
                return;
            }
            if ((value && value.length >= MinimumCharactersToTrigger) || !value || value.length === 0) {
                timeoutVal = window.setTimeout(function () {
                    window.clearTimeout(timeoutVal);
                    OnSearch(value);
                    // track the previous search so we dont fire when we dont need to
                    previousSearch.current = value;
                }, DebounceTimeout);
            }
        }
    };
    var handleOnSearchClick = function () {
        if (ref.current.value) {
            OnSearch(ref.current.value);
        }
    };
    var handleOnClearClick = function () {
        ref.current.value = "";
        OnClear();
    };
    return (React.createElement(Searcher_styles_1.ContainerDiv, null,
        React.createElement(Searcher_styles_1.SearchInput, { "aria-invalid": HasErrors, "aria-label": AriaLabel, "aria-labelledby": LabelledBy, "aria-required": IsRequired, defaultValue: InitialSearch, disabled: IsDisabled, onKeyPress: handleKeyPress, onKeyUp: handleKeyUp, placeholder: Placeholder, ref: ref, TextIndent: TextIndent, type: "search" }),
        React.createElement(Searcher_styles_1.HeadingButton, { "aria-label": Localization_1.strings.Searcher_Label_ClearSearch, disabled: IsDisabled, onClick: handleOnClearClick, title: Localization_1.strings.Searcher_Label_ClearSearch, type: "button" },
            React.createElement(CloseThinIcon_1.CloseThinIcon, null)),
        React.createElement(Searcher_styles_1.HeadingButton, { "aria-label": Localization_1.strings.Searcher_Label_Search, disabled: IsDisabled, onClick: handleOnSearchClick, title: Localization_1.strings.Searcher_Label_Search, type: "button" },
            React.createElement(SearchIcon_1.SearchIcon, null))));
});
